Criteria used to decide which events will be replayed.
